module.exports = __webpack_public_path__ + "99ca82ccae7e45dc98d2f0706444f928.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-320.webp
// module id = 342
// module chunks = 0